import { getDropdownOptions } from "helpers/DropdownHelper";
import { NotificationPriority, NotificationPriorityTranslation } from "modules/common/constants";
import React from "react";
import { Filter, ToggleSwitch } from "..";

interface Props {
    onChange: (priority: NotificationPriority) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: NotificationPriority[];
}

export const PriorityFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const renderFilter = () =>
        getDropdownOptions(NotificationPriorityTranslation).map(option => (
            <div key={option.value}>
                <ToggleSwitch
                    value={option.label}
                    checked={value.includes(option.value)}
                    onChange={() => onChange(option.value)}
                    htmlFor={option.label}
                    text={
                        <div className="filter__item__text">{option.label.toLocaleUpperCase()}</div>
                    }
                />
            </div>
        ));

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="PRIORITET"
        >
            {renderFilter()}
        </Filter>
    );
};
